/* eslint-disable camelcase */
/* global $_mod_survey */

import { get } from '../../utils/object-helpers';

export default class {
    onMount() {
        const action = get(this, 'input.action', null);
        if (action) {
            const { surveyId, storeName, username } = get(action, 'params', {});
            const { protocol, hostname } = new URL(get(action, 'URL', ''));
            window.addEventListener('load', () => {
                // eslint-disable-next-line no-undef
                if (typeof $_mod_survey !== 'undefined') {
                    $_mod_survey.ready();
                }
            });
            window.InitializeSurveys = function() {
                const ctx = {};
                if (storeName) ctx.storeName = storeName;
                if (username) ctx.username = username;
                // eslint-disable-next-line no-undef,no-new
                new SurveyPlugin({
                    target: '#str-survey',
                    survey: surveyId,
                    host: `${protocol}//${hostname}`,
                    close: true,
                    ctx
                });
            };
        }
    }
}
